/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { EventsFilter } from './EventsFilter';
import { Button } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
export const EventsList = ({ jsonData }) => {
  const all = 'All';
  const [events, setEvents] = useState([]);
  const [initialLoad, setInitialLoad] = useState(false);

  const [dropDowns, setDropdowns] = useState({
    type:
      jsonData.preSelectedType && jsonData.preSelectedType !== null
        ? jsonData.preSelectedType
        : all,
    market:
      jsonData.preSelectedMarket && jsonData.preSelectedMarket !== null
        ? jsonData.preSelectedMarket
        : all,
    region:
      jsonData.preSelectedRegion && jsonData.preSelectedRegion !== null
        ? jsonData.preSelectedRegion
        : all,
    pageIndex: 0,
  });
  const [totalCount, setTotalCount] = useState(all);

  const { control, watch, setValue } = useForm({
    defaultValues: {
      'types-filter':
        jsonData.preSelectedType && jsonData.preSelectedType !== null
          ? jsonData.preSelectedType
          : all,
      'markets-filter':
        jsonData.preSelectedMarket && jsonData.preSelectedMarket !== null
          ? jsonData.preSelectedMarket
          : all,
      'regions-filter':
        jsonData.preSelectedRegion && jsonData.preSelectedRegion !== null
          ? jsonData.preSelectedRegion
          : all,
    },
  });

  useEffect(() => {
    const loadData = async () => {
      await fetch('/corbapi/events/getevents', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          pageSize: isMobile
            ? jsonData.mobilePageSize
            : jsonData.desktopPageSize,
          pageIndex: dropDowns.pageIndex,
          typeId: dropDowns.type !== all ? dropDowns.type : null,
          marketId: dropDowns.market !== all ? dropDowns.market : null,
          regionId: dropDowns.region !== all ? dropDowns.region : null,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setTotalCount(data?.totalCount ?? 0);
          if ((data?.events?.length ?? 0) > 0) {
            if ((dropDowns.pageIndex ?? 0) === 0) {
              setEvents(data?.events ?? []);
            } else {
              const localEvents = events.concat(data.events);
              setEvents(localEvents);
            }
          } else {
            setEvents([]);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setInitialLoad(true);
        });
    };

    loadData();
  }, [dropDowns]);

  const getEvent = (event, i, isLink) => {
    return (
      <div className={isLink ? '' : 'event-item'} key={i}>
        <div className="event-header-wrapper">
          <div className="event-header">{event.name}</div>
        </div>
        <div className="event-type-wrapper">
          <div className="event-location">{event.type}</div>
          {typeof event.tag !== 'undefined' &&
            event.tag !== null &&
            event.tag !== '' && (
              <div className="event-tag">
                <i className="fa-regular fa-clock"></i>
                {event.tag}
              </div>
            )}
        </div>
        <div className="event-icons-wrapper">
          <div className="event-icon-outer date">
            <div className="icon-container">
              <i className="fa-regular fa-calendar"></i>
            </div>
            <div className="event-icon-details">{event.date}</div>
          </div>
          <div className="event-icon-outer location">
            <div className="icon-container">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <div
              className="event-icon-details"
              dangerouslySetInnerHTML={{
                __html: event.eventLocation,
              }}
            ></div>
          </div>
        </div>
        <div className="event-description-wrapper">
          <div className="event-description">{event.description}</div>
        </div>
        {typeof event.url !== 'undefined' &&
          event.url !== null &&
          event.url !== '' && (
            <div className="event-cta-wrapper">
              <div className="event-cta">
                <a href={event.url} target={event.linkTarget ?? '_self'}>
                  {event.linkText}
                  <div className="card-link-icon-wrapper">
                    <i className="fa-regular fa-arrow-up-right card-link-icon"></i>
                  </div>
                </a>
              </div>
            </div>
          )}
      </div>
    );
  };

  return (
    <div className="events-container container panel">
      <div className="container-outer">
        <div className="heading">
          <h3>{jsonData.title}</h3>
        </div>
        <div className="filter-sections">
          {jsonData.preSelectedType && jsonData.preSelectedType !== null ? (
            <></>
          ) : (
            <div className="types-filter">
              <EventsFilter
                name="types"
                allText={jsonData.allLabel}
                control={control}
                label={jsonData.typesLabel}
                list={jsonData.typesList}
                watch={watch}
                updateOnChange={(e) =>
                  setDropdowns({
                    ...dropDowns,
                    type: e.target.value,
                    pageIndex: 0,
                  })
                }
              />
            </div>
          )}

          {jsonData.preSelectedMarket && jsonData.preSelectedMarket !== null ? (
            <></>
          ) : (
            <div className="markets-filter">
              <EventsFilter
                name="markets"
                allText={jsonData.allLabel}
                control={control}
                label={jsonData.marketsLabel}
                list={jsonData.marketsList}
                watch={watch}
                updateOnChange={(e) =>
                  setDropdowns({
                    ...dropDowns,
                    market: e.target.value,
                    pageIndex: 0,
                  })
                }
              />
            </div>
          )}

          {jsonData.preSelectedRegion && jsonData.preSelectedRegion !== null ? (
            <></>
          ) : (
            <div className="regions-filter">
              <EventsFilter
                name="regions"
                allText={jsonData.allLabel}
                control={control}
                label={jsonData.regionsLabel}
                list={jsonData.regionsList}
                watch={watch}
                updateOnChange={(e) =>
                  setDropdowns({
                    ...dropDowns,
                    region: e.target.value,
                    pageIndex: 0,
                  })
                }
              />
            </div>
          )}
        </div>
        {events?.length > 0 ? (
          <div className="events-container-inner">
            <div className="totals">{`${jsonData.countLabel} 1 - ${events.length} of ${totalCount}`}</div>
            <div className="events-list">
              {events.map((event, i) => {
                return (
                  <>
                    {typeof event.url !== 'undefined' &&
                    event.url !== null &&
                    event.url !== '' ? (
                      <a
                        href={event.url}
                        target={event.linkTarget ?? '_self'}
                        className="event-item event-item-link"
                      >
                        {getEvent(event, i, true)}
                      </a>
                    ) : (
                      getEvent(event, i, false)
                    )}
                  </>
                );
              })}
            </div>
            {events.length < totalCount && (
              <div className="load-more-container">
                <div className="totals">{`${jsonData.countLabel} 1 - ${events.length} of ${totalCount}`}</div>
                <div className="button-control">
                  <Button
                    variant="contained"
                    className="btn-form"
                    size="small"
                    type="button"
                    onClick={(e) => {
                      setDropdowns({
                        ...dropDowns,
                        pageIndex: dropDowns.pageIndex + 1,
                      });
                    }}
                  >
                    {`Show ${
                      isMobile
                        ? events.length + jsonData.mobilePageSize > totalCount
                          ? totalCount - events.length
                          : jsonData.mobilePageSize
                        : events.length + jsonData.desktopPageSize > totalCount
                        ? totalCount - events.length
                        : jsonData.desktopPageSize
                    } more`}
                  </Button>
                </div>
              </div>
            )}
          </div>
        ) : (
          initialLoad && (
            <div className="no-events-section">
              <span>{jsonData.noEventsText}</span>
              <div className="button-control">
                <Button
                  variant="outlined"
                  className="btn-form"
                  size="small"
                  type="button"
                  onClick={(e) => {
                    setValue(
                      'types-filter',
                      jsonData.preSelectedType &&
                        jsonData.preSelectedType !== null
                        ? jsonData.preSelectedType
                        : all
                    );
                    setValue(
                      'markets-filter',
                      jsonData.preSelectedMarket &&
                        jsonData.preSelectedMarket !== null
                        ? jsonData.preSelectedMarket
                        : all
                    );
                    setValue(
                      'regions-filter',
                      jsonData.preSelectedRegion &&
                        jsonData.preSelectedRegion !== null
                        ? jsonData.preSelectedRegion
                        : all
                    );
                    setDropdowns({
                      type:
                        jsonData.preSelectedType &&
                        jsonData.preSelectedType !== null
                          ? jsonData.preSelectedType
                          : all,
                      market:
                        jsonData.preSelectedMarket &&
                        jsonData.preSelectedMarket !== null
                          ? jsonData.preSelectedMarket
                          : all,
                      region:
                        jsonData.preSelectedRegion &&
                        jsonData.preSelectedRegion !== null
                          ? jsonData.preSelectedRegion
                          : all,
                      pageIndex: 0,
                    });
                  }}
                >
                  {jsonData.clearFiltersLabel}
                </Button>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};
